var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7713 17.1399C13.2464 16.4613 14.1816 16.2962 14.8603 16.7713L24.0001 23.1691L33.1399 16.7713C33.8186 16.2962 34.7539 16.4613 35.229 17.1399C35.7041 17.8186 35.539 18.7539 34.8603 19.229L24.8603 26.229C24.3438 26.5905 23.6564 26.5905 23.1399 26.229L13.1399 19.229C12.4613 18.7539 12.2962 17.8186 12.7713 17.1399Z",
    fill: "#56AF31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.5C6.61929 11.5 5.5 12.6193 5.5 14V34C5.5 35.3808 6.61927 36.5 8 36.5H40C41.3808 36.5 42.5 35.3808 42.5 34V14C42.5 12.6193 41.3808 11.5 40 11.5H8ZM2.5 14C2.5 10.9624 4.96243 8.5 8 8.5H40C43.0376 8.5 45.5 10.9624 45.5 14V34C45.5 37.0376 43.0376 39.5 40 39.5H8C4.96245 39.5 2.5 37.0376 2.5 34V14Z",
    fill: "#56AF31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5779be33d69cad774741e644ccfd5481.svg";
export { ForwardRef as ReactComponent };